import { render } from "./CookieBiteIcon.vue?vue&type=template&id=39eed984"
import script from "./CookieBiteIcon.vue?vue&type=script&lang=js"
export * from "./CookieBiteIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__